const CheckInMapCommandType = {
	INIT_MAP: 'initMap',
	ADD_MARKERS: 'addMarkers',
	REMOVE_MARKERS: 'removeMarkers',
	CLEAR_MARKERS: 'clearMarkers',
	ADD_LAYERS: 'addLayers',
	REMOVE_LAYERS: 'removeLayers',
	CLEAR_LAYERS: 'clearLayers',
	FIT_BOUNDS: 'fitBounds',
	SET_ZOOM: 'setZoom',
	ZOOM_IN: 'zoomIn',
	ZOOM_OUT: 'zoomOut',
	FIT_TO_LAYERS: 'fitToLayers',
	ENABLE_CLUSTERING: 'enableClustering',
	DISABLE_CLUSTERING: 'disableClustering',
	UPDATE_CLUSTER_ICON: 'updateClusterIcon',
	UPDATE_SETTINGS: 'updateSettings',
};

export default CheckInMapCommandType;
